

<template>
  <!-- Header Area Start -->
  <header class="header_area header_black">
    <top-nav-menu/>
  </header>
  <!-- Header Area End -->
</template>
<script>
import TopNavMenu from "../components/menus/TopNavMenu";

export default {
  name: 'AppHeader',
  components: {TopNavMenu}
}
</script>



// WEBPACK FOOTER //
// src/layout/AppHeader.vue